import { render, staticRenderFns } from "./IcmsInterno.vue?vue&type=template&id=cc82e1ea&scoped=true&"
import script from "./IcmsInterno.vue?vue&type=script&lang=js&"
export * from "./IcmsInterno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc82e1ea",
  null
  
)

export default component.exports